<template>
  <div class="selects">
    <el-form>
      <el-row type="flex" justify="start" :gutter="10">
        <el-col :span="7">
          <el-form-item label="">
            <el-select v-model="selectForm.first_cat" placeholder="所有大类" @change="changeFirstCat" clearable>
              <el-option v-for="item in first_cat_list" :key="item.key" :label="item.value" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="">
            <el-select v-model="selectForm.second_cat" placeholder="所有小类" @change="change" clearable>
              <el-option v-for="item in second_cat_list" :key="item.key" :label="item.value" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="">
            <el-input v-model="selectForm.name" placeholder="工具名"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="">
            <el-button type="primary" @click="searchTools"> 搜索 </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>

  <div class="form">
    <el-form label-position="top" :rules="rules" :model="form" ref="form">
      <el-form-items prop="ToolId" required>
        <div class="collapse" v-if="tools.length > 0">
          <el-radio-group v-model.number="form.ToolId">
            <el-collapse accordion v-for="tool in tools" :key="tool.tool_id"
              :class="{ 'tool-selected': form.ToolId === tool.tool_id }">
              <el-collapse-item>
                <template v-slot:title>
                  <div class="title">
                    <el-radio :value="tool.tool_id" />
                    <span class="tool-name">{{ tool.name }}</span>
                    <span class="tool-badge" v-if="transferDict('tool_cat', tool.second_cat)">
                      {{ transferDict('tool_cat', tool.second_cat) }}
                    </span>
                  </div>
                </template>
                <div class="info-grid">
                  <div class="info-item full-width">
                    <span class="info-label">订购号</span>
                    <span class="info-value asset-number">{{ tool.asset_number }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">大区</span>
                    <span class="info-value">{{ transferDict('tool_region', tool.region) }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">小区</span>
                    <span class="info-value">{{ transferDict('tool_region', tool.small_region) }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">大类</span>
                    <span class="info-value">{{ transferDict('tool_cat', tool.first_cat) }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">小类</span>
                    <span class="info-value">{{ transferDict('tool_cat', tool.second_cat) }}</span>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </el-radio-group>
        </div>
      </el-form-items>
      <el-divider></el-divider>
      <el-form-item label="预约开始时间：" required>
        <el-col>
          <el-form-item prop="Start">
            <el-date-picker
              type="date"
              placeholder="选择开始日期"
              v-model="form.Start"
              style="width: 100%"
              value-format="YYYYMMDD"
              :disabled-date="disabledStartDate"
              @change="handelChangeStartTime"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label="预约结束时间：" required>
        <el-col>
          <el-form-item prop="End">
            <el-date-picker type="date" placeholder="选择结束日期" v-model="form.End" style="width: 100%" value-format="YYYYMMDD" :disabled-date="disabledEndDate"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label=" 备注：" prop="Remark">
        <el-col>
          <el-input v-model="form.Remark" placeholder="备注说明：" rows="5" type="textarea" />
        </el-col>
      </el-form-item>
      <el-form-item label="预约工程师：" prop="UserId" required>
        <el-col>
          <el-select v-model="form.UserId" placeholder="请选择预约工程师">
            <el-option v-for="borrower in borrowers" :key="borrower.value" :label="borrower.label" :value="borrower.value"></el-option>
          </el-select>
        </el-col>
      </el-form-item>
      <el-form-item label="收件人：" prop="receiver" required>
        <el-col>
          <el-input v-model="form.receiver" placeholder="请填写收件人姓名"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="联系电话：" prop="Tel" required>
        <el-col>
          <el-input v-model="form.Tel" placeholder="请填写电话"> </el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="收件地址：" prop="Address" required>
        <el-col>
          <el-input v-model="form.Address" placeholder="请填写地址"> </el-input>
        </el-col>
      </el-form-item>
    </el-form>
  </div>
  <el-divider></el-divider>
  <div class="operate flex-evenly-center">
    <div class="return" @click="back">返回</div>
    <div class="save" @click="submitForm">提交</div>
  </div>
</template>

<script>
import ProcessApi from '@/utils/api/process'
import ToolApi from '@/utils/api/tool'
import UserApi from '@/utils/api/user'
import { transferDict, getDict } from '@/utils/utils'
import moment from 'moment'
import { useDictStore } from '@/stores/useDictStore'
import { useUserStore } from '@/stores/useUserStore'

export default {
  name: 'CreateAppointment',

  data() {
    return {
      title: '预约工具',
      tools: [],
      borrowers: [],
      selectForm: {
        first_cat: '',
        second_cat: '',
        name: '',
        isBorrow: false,
      },
      form: {
        ToolId: '',
        Start: '',
        End: '',
        Remark: '',
        UserId: '',
        UserName: '',
        receiver: '',
        Tel: '',
        Address: '',
        IsBorrow: false,
      },
      first_cat_list: [],
      second_cat_list: [],
      dicts: [],
      rules: {
        ToolId: [{ required: true, message: '请选择预约工具', trigger: 'change' }],
        Start: [{ type: 'string', required: true, message: '请选择日期', trigger: 'change' }],
        End: [{ type: 'string', required: true, message: '请选择日期', trigger: 'change' }],
        UserId: [{ required: true, message: '请选择预约工程师', trigger: 'blur' }],
        receiver: [{ required: true, message: '请输入收件人姓名', trigger: 'blur' }],
        Tel: [{ required: true, message: '请输入电话', trigger: 'blur' }],
        Address: [{ required: true, message: '请输入收件地址', trigger: 'blur' }],
      },
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      const userStore = useUserStore()
      const user = userStore.user
      const res = await UserApi.getToolUserByDispatcher(user.user_id)
      const borrowers = []
      for (const key in res.data) {
        borrowers.push({
          label: res.data[key],
          value: key,
        })
      }
      this.borrowers = borrowers
      const dictStore = useDictStore()
      this.dicts = await dictStore.getDict()
      this.first_cat_list = getDict(this.dicts, 'tool_cat').filter((item) => !item.parentId)
    },
    back() {
      this.$router.back()
    },
    async searchTools() {
      const tools = await ToolApi.getBorrowTools(this.selectForm)
      this.tools = tools
    },
    transferDict(dictName, key) {
      return key && transferDict(this.dicts, dictName, key)
    },

    async submitForm() {
      console.log('提交表单:', this.form)
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          // 表单校验通过，执行提交操作
          // 例如：调用接口提交数据
          this.form.UserName = this.borrowers.find((v) => v.value == this.form.UserId)?.label
          ProcessApi.borrow(this.form)
            .then((res) => {
              if (res.status) {
                this.$message({
                  message: '提交成功',
                  type: 'success',
                })
                this.$router.back()
              } else {
                this.$message({
                  message: res.message || '服务器异常',
                  type: 'error',
                })
              }
            })
            .catch((err) => {
              this.$message({
                message: err?.response?.data?.message || '服务器异常',
                type: 'error',
              })
            })
        } else {
          // 表单校验不通过
          return false
        }
      })
    },
    async change() {
      console.log(this.form)
    },

    disabledStartDate(time) {
      return moment(time).isBefore(moment().startOf('day'))
    },
    disabledEndDate(time) {
      return moment(time).isBefore(moment(this.form.Start).startOf('day'))
    },
    handelChangeStartTime(val) {
      console.log('Start', val)
      this.form.End = ''
    },

    changeFirstCat(value) {
      if (!value) {
        this.second_cat_list = []
        this.selectForm.second_cat = ''
      } else {
        this.second_cat_list = getDict(this.dicts, 'tool_cat').filter((item) => item.parentId == value)
        this.selectForm.second_cat = ''
      }
    },
  },
}
</script>

<style scoped>
:deep(.el-select__wrapper) {
  border-radius: 20px !important;
}

.selects {
  width: 90vw;
  margin: 0 auto;
}

.form {
  width: 95vw;
  margin: 1rem auto;
}

.operate {
  background-color: white;
  padding: 3rem 5%;
}

.operate > div {
  width: 40%;
  font-size: 1.4rem;
  margin: 0 1rem;
  border-radius: 5px;
  padding: 1rem 0;
  cursor: pointer;
}

.operate .return {
  background-color: #a3abb4;
  color: white;
}

.operate .save {
  background-color: #0068b7;
  color: white;
}

.collapse {
  margin: 0.5rem auto;
}

.el-radio-group {
  width: 100%;
}

.collapse > div > div {
  margin: 6px 0;
  box-shadow: 0px 2px 5px 0px rgba(84, 84, 84, 0.3);
  border-radius: 6px;
  overflow: hidden;
  width: 100%;
}

/* 标题行 */
.collapse .title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  overflow: hidden;
  padding: 0.2rem 0.8rem 0.2rem 0;
}

/* 覆盖 el-radio 默认 margin-right: 32px */
.collapse .title :deep(.el-radio) {
  margin-right: 0;
  height: auto;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

/* radio 无 label 内容时隐藏多余 label 间距 */
.collapse .title :deep(.el-radio__label) {
  display: none;
  padding-left: 0;
}

.collapse .title .tool-name {
  flex: 1;
  font-size: 1.3rem;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #1a1a2e;
}

.collapse .title .tool-badge {
  flex-shrink: 0;
  font-size: 1rem;
  font-weight: normal;
  background-color: #e8f0fe;
  color: #0068b7;
  padding: 0.15rem 0.6rem;
  border-radius: 10px;
  white-space: nowrap;
}

/* 展开内容 - 信息网格 */
.info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.7rem 1.2rem;
  padding: 1.2rem 2.5rem 1.4rem;
  background-color: #fafafa;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 1.2rem;
}

.info-item.full-width {
  grid-column: 1 / -1;
  padding-bottom: 0.6rem;
  border-bottom: 1px solid #ebebeb;
  margin-bottom: 0.1rem;
}

.info-label {
  color: #909399;
  white-space: nowrap;
  font-size: 1.1rem;
  flex-shrink: 0;
}

.info-label::after {
  content: '：';
}

.info-value {
  color: #303133;
  font-weight: 500;
}

.asset-number {
  font-size: 1.3rem;
  color: #0068b7;
  font-weight: 600;
  letter-spacing: 0.03em;
}

/* 选中状态高亮 */
:deep(.tool-selected .el-collapse-item__header) {
  background-color: #e8f4ff;
  border-left: 3px solid #0068b7;
}
</style>
